import React from 'react';
import type Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { DownloadButton } from '../../../components';
import type { MediaDocument } from '../../../types/uncinc_profile/media';

interface ViewDocsProps {
  entities: Immutable.List<ImmutableEntity<MediaDocument>>;
}

const ViewDocs: React.FC<ViewDocsProps> = ({ entities }) => {
  const { t } = useTranslation();

  if (entities.size === 0) {
    return null;
  }

  return (
    <>
      <h2>{t('views.docs.title')}</h2>
      <div className="ViewDocs">
        {entities.map((entity) => {
          const media = entity.toJS();
          const mediaDocument = media.field_media_document[0];
          const mediaName = media.name[0].value;

          return (
            <DownloadButton
              className="mt-3"
              title={mediaName}
              filesize={Number(mediaDocument.size)}
              source={mediaDocument.source}
              // TODO: Dynamic mime type
              mime="PDF"
            />
          );
        })}
      </div>
    </>
  );
};

export default ViewDocs;
